import React from 'react'
import Slider from './Slider'
import Navbar from './Navbar'
import Testimonial from './Testimonial'
import DestImpactgrid from './DestImpactgrid'
import Tours from './Tours'
import DestImpacts from './DestImpact'
import Footer from './Footer'
import WhatsAppSupport from './WhatsappSupport'
import ScrollToTop from './ScrollToTop'
import Impactgrid from './Impactgrid'
import HeroSlider from './HeroSlider'
import { MegaMenu } from './MegaMenu'
const testimonialsd = [
  {
    name: "Rachna Monga",
    role: "Principal, KMV Sanskriti School",
    message:
      "With the present stratum of international exposure in school education, I indeed feel that Application Uni is the genuine path to proceed with. With highly monitored, consistent, and transparent working, the team is indeed a trendsetter. Sanskriti KMV school’s three successful trips to the USA, Canada, and Australia stand as a testimony to it.",
    stars: 5,
  },
  {
    name: "Karan Dhir",
    role: "Managing Director, Lord Krishna International School",
    message:
      "We went on an educational tour to USA NASA. All the travel arrangements were done by Application Uni. They are competent, experienced, and thorough professionals. The guide was there with us. It was a fulfilling trip, and we would like to travel again with them. I wish them good luck.",
    stars: 5,
  },
  {
    name: "Rajdeep Singh",
    role: "Managing Director, Play Ways Senior Secondary School",
    message:
      "We are pleased to acknowledge the marvellous experience we had while dealing with Application Uni, the company which took care of our students on their trip to America. It was a memorable experience as we visited NASA, which educated the students on space science. Application Uni took care of us, including food and accommodation.",
    stars: 5,
  },
  {
    name: "Sumalini Venkateswaran",
    role: "Principal, Silicon City Academy of Secondary Education",
    message:
      "We are delighted with the best service. Thank you to Application Uni for making our NASA trip truly a memorable one.",
    stars: 5,
  },
  
];

const Destinations = () => {
  return (
    <div className=''> 
      {/* <Navbar /> */}
      <MegaMenu/>
      {/* Hero Section */}
      {/* <HeroSlider/> */}
      <div className="relative h-[100vh]">
          {/* Background Image */}
          <div className="absolute inset-0 h-full">
            <img
              src="https://img.freepik.com/free-vector/vintage-world-map-cartography-concept_52683-26377.jpg?t=st=1736190829~exp=1736194429~hmac=b3528b391c428fc1bb6b20122eb1d50fe731730b04aad7c7b68b9d1c5b04bce6&w=2000"
              alt="Background"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Overlay Content */}
          <div className="absolute inset-0 z-10 flex flex-col items-center justify-center text-center px-6 md:px-8 lg:px-16 bg-black bg-opacity-60 space-y-3 lg:space-y-2">
            <h1 className="text-white text-2xl sm:text-4xl md:text-5xl lg:text-7xl font-bold  noto leading-tight lg:leading-snug">
              World Is Your Classroom
            </h1>
            <p className=' text-white hidden sm:block'> 
Expand your horizons with our overseas education programs and educational tours. Immerse yourself in different cultures, <br />acquire new perspectives, and foster both academic and personal development through life-changing international experiences.
          </p>
            <h5 className=' text-white text-xs lg:hidden'>Discover overseas educational experiences and transformative tours that will enhance your education and cultural awareness.</h5>


          </div>
        </div>
      
      <DestImpacts/>
      <Slider />
      {/* <DestImpactgrid/> */}
      <Impactgrid/>
      <Tours heading="Our Most Popular Adventures" />
      <div className='px-4 lg:px-6'>
      <Testimonial testimonials ={testimonialsd}/>
      </div>
      <ScrollToTop/>

      
      <Footer/>
    </div>
  )
}

export default Destinations